import { render, staticRenderFns } from "./ExpressCreationAddress.vue?vue&type=template&id=f204a5a2&scoped=true&"
import script from "./ExpressCreationAddress.vue?vue&type=script&lang=ts&"
export * from "./ExpressCreationAddress.vue?vue&type=script&lang=ts&"
import style0 from "./ExpressCreationAddress.vue?vue&type=style&index=0&id=f204a5a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f204a5a2",
  null
  
)

export default component.exports